interface UsersPageHeaderProps {
  title: string;
  subtitle: string;
}

export function UsersPageHeader({
  title,
  subtitle,
}: Readonly<UsersPageHeaderProps>): React.ReactElement {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
      <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
    </div>
  );
}
